export const dark = '#050608';
